/**
 * @fileoverview gRPC-Web generated client stub for witbooking.backoffice.propertymap.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../validate/validate_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.backoffice = {};
proto.witbooking.backoffice.propertymap = {};
proto.witbooking.backoffice.propertymap.v1 = require('./propertymap_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.propertymap.v1.PropertyMapAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.backoffice.propertymap.v1.PropertyMapAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest,
 *   !proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse>}
 */
const methodDescriptor_PropertyMapAPI_GetPropertyMap = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.propertymap.v1.PropertyMapAPI/GetPropertyMap',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest,
  proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse,
  /**
   * @param {!proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest,
 *   !proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse>}
 */
const methodInfo_PropertyMapAPI_GetPropertyMap = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse,
  /**
   * @param {!proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.propertymap.v1.PropertyMapAPIClient.prototype.getPropertyMap =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.propertymap.v1.PropertyMapAPI/GetPropertyMap',
      request,
      metadata || {},
      methodDescriptor_PropertyMapAPI_GetPropertyMap,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.propertymap.v1.GetPropertyMapRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.propertymap.v1.GetPropertyMapResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.propertymap.v1.PropertyMapAPIPromiseClient.prototype.getPropertyMap =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.propertymap.v1.PropertyMapAPI/GetPropertyMap',
      request,
      metadata || {},
      methodDescriptor_PropertyMapAPI_GetPropertyMap);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest,
 *   !proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse>}
 */
const methodDescriptor_PropertyMapAPI_CreateOrReplacePropertyMap = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.propertymap.v1.PropertyMapAPI/CreateOrReplacePropertyMap',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest,
  proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse,
  /**
   * @param {!proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest,
 *   !proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse>}
 */
const methodInfo_PropertyMapAPI_CreateOrReplacePropertyMap = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse,
  /**
   * @param {!proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.propertymap.v1.PropertyMapAPIClient.prototype.createOrReplacePropertyMap =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.propertymap.v1.PropertyMapAPI/CreateOrReplacePropertyMap',
      request,
      metadata || {},
      methodDescriptor_PropertyMapAPI_CreateOrReplacePropertyMap,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.propertymap.v1.CreateOrReplacePropertyMapResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.propertymap.v1.PropertyMapAPIPromiseClient.prototype.createOrReplacePropertyMap =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.propertymap.v1.PropertyMapAPI/CreateOrReplacePropertyMap',
      request,
      metadata || {},
      methodDescriptor_PropertyMapAPI_CreateOrReplacePropertyMap);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest,
 *   !proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse>}
 */
const methodDescriptor_PropertyMapAPI_DeletePropertyMap = new grpc.web.MethodDescriptor(
  '/witbooking.backoffice.propertymap.v1.PropertyMapAPI/DeletePropertyMap',
  grpc.web.MethodType.UNARY,
  proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest,
  proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse,
  /**
   * @param {!proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest,
 *   !proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse>}
 */
const methodInfo_PropertyMapAPI_DeletePropertyMap = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse,
  /**
   * @param {!proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.backoffice.propertymap.v1.PropertyMapAPIClient.prototype.deletePropertyMap =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.backoffice.propertymap.v1.PropertyMapAPI/DeletePropertyMap',
      request,
      metadata || {},
      methodDescriptor_PropertyMapAPI_DeletePropertyMap,
      callback);
};


/**
 * @param {!proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.backoffice.propertymap.v1.DeletePropertyMapResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.backoffice.propertymap.v1.PropertyMapAPIPromiseClient.prototype.deletePropertyMap =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.backoffice.propertymap.v1.PropertyMapAPI/DeletePropertyMap',
      request,
      metadata || {},
      methodDescriptor_PropertyMapAPI_DeletePropertyMap);
};


module.exports = proto.witbooking.backoffice.propertymap.v1;

